import React, { Component } from "react";
import {
  Typography,
  Paper,
  Tabs as Tabs1,
  Tab as Tab1,
} from "@material-ui/core";
import { GetData } from "../../api/service";
import AcademicAbout from "../Academics/AcademicAbout";
import CollegeNotificationShort from "../College/CollegeNotificationShort";

const smallTab = [
  {
    title: "Message from the Principal",
    active: 0,
  },
  {
    title: "Message from the Coordinator",
    active: 1,
  },
  {
    title: "Dispur College at a Glance",
    active: 2,
  },
  {
    title: "About the Cell",
    active: 3,
  },
  {
    title: "Genesis",
    active: 4,
  },
  {
    title: "Organogram",
    active: 5,
  },
];

class AboutUsHomeLanding extends Component {
  state = {
    active: 0,
    dept_code: "DISPUR",

    data: {},
    isDeptLoaded: false,
  };

  __getDeptData = (dept_code) => {
    GetData(`/admin/${dept_code}/getsingledeptdata`).then((resp) => {
      if (resp != false) {
        this.setState({
          data: resp,
          active: 0,
          isDeptLoaded: true,
        });
      } else {
        this.setState({
          data: {},
          active: 0,
          isDeptLoaded: true,
        });
      }
    });
  };

  componentDidMount() {
    this.__getDeptData(this.state.dept_code);
  }

  render() {
    return (
      <div>
        <Typography variant="h6">About Us</Typography>
        <Typography variant="subtitle2">
          Code: {this.state.dept_code}
        </Typography>

        <br />

        {this.state.isDeptLoaded && (
          <Paper square>
            <Tabs1
              value={this.state.active}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              onChange={(e, newValue) =>
                this.setState({
                  active: newValue,
                })
              }
              aria-label=""
            >
              {smallTab.map((el, index) => (
                <Tab1 value={el.active} key={el.active} label={el.title} />
              ))}
            </Tabs1>
          </Paper>
        )}
        <br />

        {this.state.active == 0 ? (
          <AcademicAbout
            type={`ABOUTUS_PRINCIPAL_MESSAGE`}
            title="Message from the Principal"
          />
        ) : null}

        {this.state.active == 1 ? (
          <AcademicAbout
            type={`ABOUTUS_COORDINATOR_MESSAGE`}
            title="Message from the Coordinator"
          />
        ) : null}

        {this.state.active == 2 ? (
          <AcademicAbout
            type={`ABOUTUS_COLLEGE_GLANCE`}
            title="Dispur College at a Glance"
          />
        ) : null}

        {this.state.active == 3 ? (
          <AcademicAbout
            type={`ABOUTUS_ABOUT_THE_CELL`}
            title="About the Cell"
          />
        ) : null}

        {this.state.active == 4 ? (
          <AcademicAbout type={`ABOUTUS_GENESIS`} title="Genesis" />
        ) : null}

        {this.state.active == 5 ? (
          <CollegeNotificationShort
            type={`ABOUTUS_ORGANOGRAM`}
            title="Organogram"
          />
        ) : null}
      </div>
    );
  }
}

export default AboutUsHomeLanding;
